/* The ingredients scroll inside the panel, so Cancel/Add stay on screen
   however long the recipe is. */
.panel {
	background: var(--surface-card);
	border-radius: var(--radius-lg);
	padding: var(--space-5);
	display: flex;
	flex-direction: column;
	gap: var(--space-4);
	max-height: var(--dialog-max-h);
	box-sizing: border-box;
}

.heading {
	margin: 0;
	font-size: 1rem;
	font-weight: 600;
}

/* The recipe the ingredients come from. */
.subheading {
	margin: 2px 0 0;
	font-size: 0.875rem;
	color: var(--ink-muted);
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.listRow {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: var(--space-3);
}

.label {
	color: var(--ink-muted);
	font-family: var(--font-ui);
	font-size: 0.875rem;
	font-weight: 600;
}

.ingredients {
	flex: 1;
	min-height: 0;
	overflow-y: auto;
	display: flex;
	flex-direction: column;
	gap: var(--space-2);
}

.ingredientsHead {
	display: flex;
	align-items: baseline;
	justify-content: space-between;
	gap: var(--space-3);
}

.selectAll {
	padding: 0;
	border: none;
	background: none;
	color: var(--ink-muted);
	font: inherit;
	font-size: 0.875rem;
	text-decoration: underline;
	cursor: pointer;
}

.selectAll:hover {
	color: var(--ink);
}

.sectionHeading {
	margin: var(--space-2) 0 0;
	font-size: 0.875rem;
	font-weight: 600;
}

.list {
	list-style: none;
	margin: 0;
	padding: 0;
}

/* Padding on the label, so the gaps between rows tick too. */
.check {
	display: flex;
	align-items: flex-start;
	padding: var(--space-2) 0;
	line-height: 1.4;
}

.error {
	margin: 0;
	font-size: 0.8125rem;
	line-height: 1.4;
	text-wrap: pretty;
	color: var(--accent-rose);
}

.actions {
	display: flex;
	gap: var(--space-2);
	justify-content: flex-end;
}

.primary,
.secondary {
	border-radius: var(--radius-sm);
	padding: var(--space-2) var(--space-4);
	font: inherit;
	font-weight: 600;
	cursor: pointer;
}

.primary {
	background: var(--accent-sage);
	color: #fff;
	border: none;
}

.secondary {
	background: none;
	color: var(--ink-muted);
	border: 1px solid var(--border);
}

.primary:disabled,
.secondary:disabled {
	opacity: 0.5;
	cursor: not-allowed;
}
